export default {
  computed: {
    emailMarketingRoutes() {
      return {
        "email-marketing-active-campaign": {
          title: "Active Campaign"
        },

        "email-marketing-lead-lovers": {
          title: "Lead Lovers"
        },

        "email-marketing-rd-station": {
          title: "RD Station Marketing"
        }
      }
    }
  }
}